import { DataVolume, Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Transaction } from './Transaction';

export interface TransRowRow {
  trans_id: string;
  entity_id: string;
  key: string;
  action: string;
  after: string;
}

export const TransRow: Entity<TransRowRow> = {
  id: 'TransRow',
  title: 'TransRow',
  service: 'main',
  rowLabel: (row: TransRowRow) => `${row.trans_id} / ${row.entity_id} / ${row.key}`,
  primaryKeyFields: ['trans_id', 'entity_id', 'key'],
  source: {
    tableName: 'public.trans_row',
  },
  security: [{ role: 'staff', action: 'read', access: 'all' }],
  defaultSort: [
    ['entity_id', 'ASC'],
    ['key', 'ASC'],
  ],
  defaultFilters: [{ fieldId: 'trans_id', operator: 'ct', value: '' }],
  dataVolume: DataVolume.Large,
  fields: {
    trans_id: {
      seq: 5,
      type: FieldType.Reference,
      label: 'Transaction Id',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
      refEntity: Transaction,
    },
    entity_id: {
      seq: 10,
      type: FieldType.Text,
      label: 'Entity Id',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    key: {
      seq: 15,
      type: FieldType.Text,
      label: 'Key',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    action: {
      seq: 20,
      type: FieldType.Options,
      label: 'Action',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
      options: [
        {
          id: 'C',
          label: 'Create',
        },
        {
          id: 'U',
          label: 'Update',
        },
        {
          id: 'D',
          label: 'Delete',
        },
      ],
    },
    after: {
      seq: 25,
      type: FieldType.Text,
      label: 'After Data',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};
